<template>
  <div class="wait_data" v-if="wait_data">
    <div class="d-flex justify-content-center p-10">
      <div class="spinner-border" style="width: 8rem; height: 8rem;" role="status">
        <span class="sr-only">Chargement...</span>
      </div>
    </div>
  </div>
</template>


<script>

export default {

  props: {
    wait_data: true,
  },


  mounted() {
  },

}
</script>

<style scoped>
.wait_data {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  z-index: 100000;
  opacity: .8;
  transition: opacity .15s linear;
}
</style>